import React, { useState, useEffect, useContext } from 'react';
import cn from 'classnames';
import { withStyles } from '@material-ui/styles';
import { OrderDetailContextProvider, useOrderDetailContext } from './OrderDetailContext';
import queryString from 'query-string';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import Button from '@material-ui/core/Button';
import { AppContext } from '../../AppContext';
import { OrderDetailContext } from './OrderDetailContext';
import roles from '../../helpers/roles';

// SERVICES
import { getOrderById, getClient } from '../../services';

// TABS
import { TabBar } from '../TabBar';
import {
  OrderDetailDetailTab,
  OrderDetailServicesTab,
  OrderDetailHistoryTab,
  OrderDetailCommunicationTab,
  OrderDetailActionsTab,
  OrderDetailInstructionsTab,
  OrderDetailAttachedDocsTab,
  OrderDetailMapTab,
  OrderDetailBetterViewiFrameTab,
  OrderDetailVexceliFrameTab,
} from './orderDetailTabs';

const { ADMIN, QA, UNDERWRITER, UNDERWRITER_READONLY, FIELD_REP, CALLCENTER } = roles;

const styles = theme => ({
  blue: {
    backgroundColor: 'blue',
  },

  clientLogo: {
    height: '75%',
    marginLeft: 20,
    maxWidth: 200,
    maxHeight: 50,
  },
});

export const ORDER_DETAIL_TAB_KEY = 'ORDER_DETAIL_TAB';
export const tabKeys = {
  details: 'details',
  services: 'services',
  history: 'history',
  communication: 'communication',
  actions: 'actions',
  instructions: 'instructions',
  attachedDocs: 'attachedDocs',
  map: 'map',
  // betterViewiFrame: 'betterViewiFrame',
  vexceliFrame: 'vexceliFrame',
};

const OrderDetailContent = withStyles(styles)(props => {
  const { classes, setPageTitle } = props;
  const { orderLineId } = props.match.params;

  const {
    state: { roles: userRoles },
  } = useContext(AppContext);
  const { dispatch } = useOrderDetailContext();

  const state = useContext(AppContext);

  const [client, setClient] = useState({
    loading: false,
    result: null,
  });

  const [clientId, setClientId] = useState(null);

  const [query] = useState(queryString.parse(props.history.location.search));
  const [activeTab, setActiveTab] = useState(0);
  const [allowedTabs, setAllowedTabs] = useState([]);
  const [tabsLoaded, setTabsLoaded] = useState({
    details: false,
    services: false,
    history: false,
    communication: false,
    actions: false,
    instructions: false,
    attachedDocs: false,
    map: false,
    // betterViewiFrame: false,
    vexceliFrame: false,
  });

  const updateLoaded = (tabKey, value) => {
    setTabsLoaded(Object.assign({}, tabsLoaded, { [tabKey]: value }));
  };

  const updateActiveTab = key => {
    localStorage.setItem(ORDER_DETAIL_TAB_KEY, key);
    const activeTabIndex = allowedTabs.findIndex(tab => tab.key === key);
    setActiveTab(activeTabIndex);
  };

  const buildPageTitle = ({ orderLineStatusLookup: { code, descript }, policy: { clientId } }) => {
    setClientId(clientId);
    setPageTitle(
      <div className={cn('row-start-center')}>
        <span>Order Details</span>
        <img
          src={`https://jmistorage.blob.core.windows.net/clientid-${clientId}/logo.jpg`}
          className={cn(classes.clientLogo, 'mx-20')}
        />
        <span
          style={{
            fontSize: '1.2rem',
            opacity: 0.8,
          }}
        >
          {code}
        </span>
      </div>,
    );
  };

  const getOrderData = async () => {
    try {
      dispatch({
        type: 'CLEAR_DETAIL',
      });
      let orderDetail = await getOrderById(orderLineId);
      dispatch({
        type: 'UPDATE_DETAIL',
        detail: orderDetail,
      });
      buildPageTitle(orderDetail);
    } catch (error) {
      console.log(error);
    }
  };

  const tabs = [
    {
      label: 'Details',
      key: tabKeys.details,
      permissions: [ADMIN, CALLCENTER],
      component: (
        <OrderDetailDetailTab
          orderLineId={orderLineId}
          loaded={tabsLoaded.details}
          updateLoaded={val => updateLoaded('details', val)}
          query={query}
          fetchOrderData={getOrderData}
        />
      ),
    },
    {
      label: 'Services',
      key: tabKeys.services,
      permissions: [ADMIN, CALLCENTER],
      component: (
        <OrderDetailServicesTab
          orderLineId={orderLineId}
          loaded={tabsLoaded.services}
          updateLoaded={val => updateLoaded('services', val)}
          query={query}
        />
      ),
    },
    {
      label: 'History',
      key: tabKeys.history,
      permissions: [ADMIN, CALLCENTER],
      component: (
        <OrderDetailHistoryTab
          orderLineId={orderLineId}
          loaded={tabsLoaded.history}
          updateLoaded={val => updateLoaded('services', val)}
          query={query}
        />
      ),
    },
    {
      label: 'Communication',
      key: tabKeys.communication,
      permissions: [ADMIN, QA, UNDERWRITER, UNDERWRITER_READONLY, FIELD_REP, CALLCENTER],
      component: (
        <OrderDetailCommunicationTab
          orderLineId={orderLineId}
          loaded={tabsLoaded.communication}
          updateLoaded={val => updateLoaded('communication', val)}
          query={query}
        />
      ),
    },
    {
      label: 'Actions',
      key: tabKeys.actions,
      permissions: [ADMIN, QA, CALLCENTER],
      component: (
        <OrderDetailActionsTab
          orderLineId={orderLineId}
          loaded={tabsLoaded.actions}
          updateLoaded={val => updateLoaded('actions', val)}
          query={query}
          fetchOrderData={getOrderData}
          client={client}
        />
      ),
    },
    {
      label: 'Instructions',
      key: tabKeys.instructions,
      permissions: [ADMIN, CALLCENTER],
      component: (
        <OrderDetailInstructionsTab
          orderLineId={orderLineId}
          loaded={tabsLoaded.instructions}
          updateLoaded={val => updateLoaded('instructionsactions', val)}
          query={query}
        />
      ),
    },
    {
      label: 'Attached Docs',
      key: tabKeys.attachedDocs,
      permissions: [ADMIN, CALLCENTER],
      component: (
        <OrderDetailAttachedDocsTab
          orderLineId={orderLineId}
          loaded={tabsLoaded.attachedDocs}
          updateLoaded={val => updateLoaded('instructionsactions', val)}
          query={query}
        />
      ),
    },
    {
      label: 'Map',
      key: tabKeys.map,
      permissions: [ADMIN],
      component: (
        <OrderDetailMapTab
          orderLineId={orderLineId}
          loaded={tabsLoaded.map}
          updateLoaded={val => updateLoaded('map', val)}
          query={query}
        />
      ),
    },
    // {
    //   label: 'BetterView',
    //   key: tabKeys.betterViewiFrame,
    //   permissions: [ADMIN],
    //   component: (
    //     <OrderDetailBetterViewiFrameTab
    //       orderLineId={orderLineId}
    //       loaded={tabsLoaded.map}
    //       updateLoaded={val => updateLoaded('map', val)}
    //       query={query}
    //     />
    //   ),
    // },
    {
      label: 'Vexcel',
      key: tabKeys.vexceliFrame,
      permissions: [ADMIN],
      component: (
        <OrderDetailVexceliFrameTab
          orderLineId={orderLineId}
          loaded={tabsLoaded.map}
          updateLoaded={val => updateLoaded('map', val)}
          query={query}
        />
      ),
    },
  ];

  const checkLastFocusedTabKey = () => {
    const lastFocusedTab = localStorage.getItem(ORDER_DETAIL_TAB_KEY);

    if (lastFocusedTab) {
      updateActiveTab(lastFocusedTab);
    } else {
      setActiveTab(0); // set to the first tab on the page
    }
  };

  // whenever the allowed tabs change (when the page loads and the roles are brought in), check what the last focused tab was
  useEffect(() => {
    checkLastFocusedTabKey();
  }, [allowedTabs]);

  useEffect(() => {
    setAllowedTabs(tabs.filter(tab => tab.permissions.some(permission => userRoles.indexOf(permission) >= 0)));
  }, [userRoles]);

  useEffect(() => {
    getOrderData();

    return () => {
      localStorage.removeItem(ORDER_DETAIL_TAB_KEY);
    };
  }, []);

  return (
    <div className={cn('flex-1', 'col-center-start')}>
      {query.referrer && (
        <Button style={{ marginBottom: 10 }} onClick={() => props.history.goBack()}>
          <ChevronLeft />
          Return to {query.referrer}
        </Button>
      )}
      <TabBar tabs={allowedTabs} changeTab={updateActiveTab} activeTab={activeTab} />

      <div
        className={cn(
          'card',
          'my-10',
          ![tabs.communication].includes(activeTab) && 'flex-1',
          'align-stretch',
          'border-left-green',
        )}
        style={{
          position: 'relative',
        }}
      >
        {allowedTabs[activeTab] && allowedTabs[activeTab].component}
      </div>
    </div>
  );
});

export const OrderDetail = props => (
  <OrderDetailContextProvider>
    <OrderDetailContent {...props} />
  </OrderDetailContextProvider>
);
